export interface IWatermarkSet {
  id: number;
  uuid: string;
  channel: number;
  name: string;
  elements: IWatermarkElement[];
}

export type CreateWatermarkSet = Omit<IWatermarkSet, 'id' | 'uuid'>;

export enum WatermarkElementTypes {
  email = 'email',
  date = 'date',
  time = 'time',
  datetime = 'datetime',
  image = 'image',
  custom = 'custom',
}

export interface ITextTypeSettings {
  font: {
    url: string;
    name: string;
    letterSpacing?: string;
    style?: 'normal' | 'italic';
    weight?: 'bold' | 'lighter' | '600';
    caps?: boolean;
  };
  font_size: number;
  color: string;
  value: string;
}

export interface IImageTypeSettings {
  original_url: string;
  url: string;
  opacity?: number;
}

export interface IDimensions {
  x: number;
  y: number;
  scale: number;
  rotation: number;
  height?: number;
  width?: number;
}

export interface IWatermarkElement {
  uuid: string;
  type: WatermarkElementTypes;
  settings: {
    text: ITextTypeSettings;
    image: IImageTypeSettings;
    dimensions: IDimensions;
    repeat: boolean;
    duration: string; // enum TODO once options are known
    opacity?: number;
  };
}
